import { trpc } from '@tencent/tpro_rmonitor_manage_server_issue_track';
import { getUserId } from '@/infrastructure/auth';
import { TRPCPost } from '@/infrastructure/axios';
import { API_PREFIX } from '@/infrastructure/axios/code';
import { logger } from '@/infrastructure/logger';
import { getProductId } from '@/infrastructure/product-info';
import { WithTypeCast } from '@raft/utils';

// 类型定义
type ICreateWebhookProjectReq = WithTypeCast<trpc.rmonitor.manage_server.ICreateWebhookProjectReq>;
type ICreateWebhookProjectRsp = WithTypeCast<trpc.rmonitor.manage_server.ICreateWebhookProjectRsp>;
type IGetWebhookProjectsRsp = WithTypeCast<trpc.rmonitor.manage_server.IGetWebhookProjectsRsp>;
type IUpdateWebhookProjectReq = WithTypeCast<trpc.rmonitor.manage_server.IUpdateWebhookProjectReq>;
type IUpdateWebhookProjectRsp = WithTypeCast<trpc.rmonitor.manage_server.IUpdateWebhookProjectRsp>;
type IDeleteWebhookProjectsReq = WithTypeCast<trpc.rmonitor.manage_server.IDeleteWebhookProjectsReq>;
type IDeleteWebhookProjectsRsp = WithTypeCast<trpc.rmonitor.manage_server.IDeleteWebhookProjectsRsp>;

export type IWebhookProjectInfo = WithTypeCast<trpc.rmonitor.manage_server.GetWebhookProjectsRsp.IWebhookProjectInfo>;

// 请求配置
export const axiosRequestConfig = () => ({
  headers: {
    'Content-Type': 'application/json',
    'Server-Type': 'trpc',
    staffName: getUserId(),
    tenantKey: getProductId(),
  },
});

// 创建Webhook项目
export const createWebhookProject = async (body: ICreateWebhookProjectReq) => {
  try {
    const resp: ICreateWebhookProjectRsp = await TRPCPost(
      `/${API_PREFIX}/trpc/trpc.rmonitor.manage_server.IssueTrack/CreateWebhookProject`,
      {
        projectName: body.projectName,
        webhook: body.webhook,
        templateTitlePrefix: body.templateTitlePrefix,
        data: body.data,
      },
      axiosRequestConfig(),
    );
    return resp.baseRsp;
  } catch (e) {
    logger.error('createWebhookProject err', e);
    return {};
  }
};

// 获取Webhook项目列表
export const getWebhookProjects = async () => {
  try {
    const resp: IGetWebhookProjectsRsp = await TRPCPost(
      `/${API_PREFIX}/trpc/trpc.rmonitor.manage_server.IssueTrack/GetWebhookProjects`,
      axiosRequestConfig(),
    );
    const data = resp.infos || [];
    return data;
  } catch (e) {
    logger.error('getWebhookProjects err', e);
    return [];
  }
};

// 更新Webhook项目
export const updateWebhookProject = async (body: IUpdateWebhookProjectReq) => {
  try {
    const resp: IUpdateWebhookProjectRsp = await TRPCPost(
      `/${API_PREFIX}/trpc/trpc.rmonitor.manage_server.IssueTrack/UpdateWebhookProject`,
      {
        projectId: body.projectId,
        webhook: body.webhook,
        templateTitlePrefix: body.templateTitlePrefix,
        data: body.data,
      },
      axiosRequestConfig(),
    );
    return resp.baseRsp;
  } catch (e) {
    logger.error('updateWebhookProject err', e);
    return {};
  }
};

// 删除Webhook项目（批量）
export const deleteWebhookProjects = async (body: IDeleteWebhookProjectsReq) => {
  try {
    const resp: IDeleteWebhookProjectsRsp = await TRPCPost(
      `/${API_PREFIX}/trpc/trpc.rmonitor.manage_server.IssueTrack/DeleteWebhookProjects`,
      {
        projectIds: body.projectIds,
      },
      axiosRequestConfig(),
    );
    return resp.baseRsp;
  } catch (e) {
    logger.error('deleteWebhookProjects err', e);
    return {};
  }
};
